import { render, staticRenderFns } from "./SchoolList.vue?vue&type=template&id=f3238cbc&scoped=true"
import script from "./SchoolList.vue?vue&type=script&lang=js"
export * from "./SchoolList.vue?vue&type=script&lang=js"
import style0 from "./SchoolList.vue?vue&type=style&index=0&id=f3238cbc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3238cbc",
  null
  
)

export default component.exports